import script from "./MobileUnderGraduatePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileUnderGraduatePage.vue?vue&type=script&lang=ts&setup=true"

import "./MobileUnderGraduatePage.vue?vue&type=style&index=0&id=14cf80ec&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14cf80ec"]])

export default __exports__